import { motion } from "framer-motion";

import PageTransition from "../../components/PageTransition/PageTransition";
import logo from "../../assets/img/logo.png";

import "./Home.css";

const itemVariants = {
  hidden: {
    opacity: 0,
    y: 20,
  },
  visible: {
    opacity: 1,
    y: 0,
  },
};

function Home() {
  return (
    <PageTransition>
      <section className="hero__content" aria-label="Ostrovskyi Company">
        <motion.header
          className="hero__header"
          variants={itemVariants}
          initial="hidden"
          animate="visible"
          transition={{ duration: 0.7, delay: 0.15 }}
        >
          <span className="hero__decor" aria-hidden="true" />
          Ostrovskyi Company
        </motion.header>

        <motion.img
          className="hero__logo"
          src={logo}
          alt="Ostrovskyi Company logo"
          variants={itemVariants}
          initial="hidden"
          animate="visible"
          transition={{ duration: 0.8, delay: 0.3 }}
        />

        <motion.h1
          className="hero__title"
          variants={itemVariants}
          initial="hidden"
          animate="visible"
          transition={{ duration: 0.8, delay: 0.45 }}
        >
          Knowledge. Confidence. Impact.
        </motion.h1>

        <motion.div
          className="hero__divider"
          aria-hidden="true"
          variants={itemVariants}
          initial="hidden"
          animate="visible"
          transition={{ duration: 0.8, delay: 0.6 }}
        >
          <span />
        </motion.div>

        <motion.h2
          className="hero__subtitle"
          variants={itemVariants}
          initial="hidden"
          animate="visible"
          transition={{ duration: 0.8, delay: 0.75 }}
        >
          Consultancy <br /> that empowers
        </motion.h2>
      </section>
    </PageTransition>
  );
}

export default Home;
